import React from "react";
import { Redirect } from "react-router-dom";

import dashboardRoutes from "./views/dashboard/DashboardRoutes";

import configurationRoutes from "./views/configurations/configurationRoutes";
import applicationRoutes from "./views/applications/applicationRoutes"
import vesselRoutes from "./views/vessel/vesselRoutes";
import workBenchRoutes from "./views/workbench/workbenchRoutes";
import dailyActivityRoutes from "./views/dailyActivityBoard/dailyActivityRoutes";
import administrationRoutes from "./views/administrations/administrationRoutes";


const redirectRoute = [
  {
    path: "/",
    exact: true,
    component: () => <Redirect to="/applications/home" />
  },
];

const errorRoute = [
  {
    component: () => <Redirect to="/session/404" />,
  },
];

const routes = [
  ...redirectRoute,
  ...dashboardRoutes,
  ...applicationRoutes,
  ...vesselRoutes,
  ...dailyActivityRoutes,
  ...configurationRoutes,
  ...workBenchRoutes,
  ...administrationRoutes,
  ...errorRoute,
];

export default routes;
